import {Root} from '@radix-ui/react-form';
import {forwardRef} from 'react';

interface FormProps {
  children: React.ReactNode;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
}

const Form = forwardRef<HTMLFormElement, FormProps>(({children, onSubmit}, ref) => {
  return (
    <Root ref={ref} onSubmit={onSubmit}>
      {children}
    </Root>
  );
});

export default Form;
